var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-form-item",
    { attrs: { label: _vm.name, prop: _vm.name, rules: _vm.rules } },
    [
      _c("el-input-number", {
        ref: "numberInput",
        attrs: {
          type: "text",
          disabled: _vm.disabled,
          precision: _vm.precision,
          min: _vm.min,
          max: _vm.max,
          step: _vm.step,
        },
        on: { input: _vm.input },
        model: {
          value: _vm.val,
          callback: function ($$v) {
            _vm.val = $$v
          },
          expression: "val",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }